// extracted by mini-css-extract-plugin
export default {"empty":"EventsEmptyState_empty__r-ESL","img":"EventsEmptyState_img__Trxqk"};